module.exports = __webpack_public_path__ + "img/erweima.1dae1ef5.png";